import ApolloClient, { InMemoryCache } from "apollo-boost";
import axios from 'axios';
import {trackPosthog} from "../tracking/tracking";
import {OpenAPI} from "../../generated";
import useAuthState from "../../zustand/authState";
import { getAuth } from "firebase/auth";

let debugOutput = false;
declare var window: any;

export const isTestOrLocal = () => {
    let result = false;

    if (process.env.NODE_ENV === 'development') {
        result = true;
    }

    if (process.env.NEXT_PUBLIC_ENVIRONMENT === "dev") {
        result = true;
    }

    if (typeof window !== 'undefined') {
        if (window.location.href.startsWith('https://dev') ||
            window.location.href.startsWith('https://shauben-duofamily') ||
            window.location.href.indexOf('localhost') !== -1) {
            result = true;
        }

        // enable debug output via F12 and global variable
        if (window.debugMode) {
            result = true;
        }

    }

    if (!debugOutput) {
        debugOutput = true;
    }

    return result;
}

export const getStrapiUri = () => {
    return process.env.NEXT_PUBLIC_STRAPI_URL;
}

export const getAPIUrl = () => {
    return process.env.NEXT_PUBLIC_API_URL;
}

export const getStrapiApollo = () => {
    return new ApolloClient(
        {
            uri: process.env.NODE_ENV === 'development' ?
                 getStrapiUri() + "/graphql" : getAPIUrl() + "/graphql",
            cache: new InMemoryCache(),
            onError: (error) => {
                // for more infos on digital ocean deployment error
                console.log('*** Apollo Error Occured');
                console.log(error);
            }
        }
    );
};

export const getStripePublicKey = () => {
    if (isTestOrLocal()) {
        return "pk_test_927WCgDSCufEhlX34TeVvtW20051qmpZAT";
    } else {
        return "pk_live_IDbAozmAFwMkU5iXxMVu650h00NLDrDFVE";
    }
}

const axiosInstance = axios.create( { baseURL: getStrapiUri() } );
const axiosAPIInstance = axios.create( { baseURL: getAPIUrl() } );

OpenAPI.BASE = getAPIUrl();

OpenAPI.HEADERS = async () => {

    if (typeof window === 'undefined') {
        return { };
    }

    const token = useAuthState.getState().idToken;

    if (!token) {
        return {
            'LocationHref': window?.location.href
        };
    }

    return {
        'CustomAuth': token,
        'LocationHref': window?.location.href
    }
}

const axiosInterceptor = async (config) => {

    if (typeof window === 'undefined') {
        return config;
    }

    const token = useAuthState.getState().idToken;

    if (!token) {
        config.headers = {
            'LocationHref': window?.location.href
        };

        return config;
    }

    config.headers = {
        'CustomAuth': token,
        'LocationHref': window?.location.href
    }

    return config;
};

axiosInstance.interceptors.request.use(axiosInterceptor);
axiosAPIInstance.interceptors.request.use(axiosInterceptor);

axiosInstance.interceptors.response.use(
    (res) => {
        const url = res.config.url;
        const headers = res.config.headers;
        const configData = res.config.data;
        const method = res.config.method;
        const data = res.data;

        trackPosthog(`strapi api ${method} ${url}`, { requestMethod: method,  requestData: configData, responseUrl: url } );
        return res;
    },
    (err) => {
        trackPosthog("api-strapi-error", err);
        return Promise.reject(err);
    }
);

axiosAPIInstance.interceptors.response.use(
    (res) => {
        if (typeof window === 'undefined') {
            return;
        }

        const url = res.config.url;
        const headers = res.config.headers;
        const configData = res.config.data;
        const method = res.config.method;
        const data = res.data;

        trackPosthog(`api ${method} ${url}`, { requestMethod: method, requestData: configData, responseUrl: url } );
        return res;
    },
    (err) => {
        if (err.response) {
            if (typeof window === 'undefined') {
                return;
            }

            const data = err.response.data;
            const status = err.response.status;
            const headers = err.response.headers;

            trackPosthog("api-error", { error: err, responseData: data, responseStatus: status, responseHeaders: headers });


            // forbidden resource - not authorized (invalid token?)
            if (status === 403) {
                console.log('*** status 403 occurred');
                trackPosthog("api-error-403");

                window.signOut403 = true;
                getAuth().signOut();
            }

        } else {
            trackPosthog("api-error", err);
        }
        return Promise.reject(err);
    }
)

export const getAxios = () => {
    return axiosInstance;
}

export const getAPIAxios = () => {
    return axiosAPIInstance;
}
